import { render } from "./CardText.vue?vue&type=template&id=2d4f122a"
import script from "./CardText.vue?vue&type=script&lang=js"
export * from "./CardText.vue?vue&type=script&lang=js"

import "./CardText.vue?vue&type=style&index=0&id=2d4f122a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__